import React from 'react';
import { FileText, type LucideIcon } from 'lucide-react';

export function LoadingSpinner({ size = 16, className = '' }: { size?: number; className?: string }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="relative" style={{ width: size, height: size }}>
        <div className="absolute inset-0 rounded-full border-2 border-current opacity-20" />
        <div className="absolute inset-0 animate-spin rounded-full border-2 border-current border-t-transparent" />
      </div>
    </div>
  );
}

export function LoadingDocument({
  text = 'Loading preview...',
  icon: Icon = FileText,
  className = '',
}: {
  text?: string;
  icon?: LucideIcon;
  className?: string;
}) {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className="relative mb-6 flex items-center justify-center">
        <div className="relative z-20 rounded-full border border-slate-100 bg-white p-3 shadow-sm">
          <Icon size={28} className="text-primary opacity-90" />
        </div>
        <div className="absolute inset-0 -m-3 rounded-full border border-slate-100" />
        <div
          className="absolute inset-0 -m-3 animate-spin"
          style={{ animationDuration: '3s', animationTimingFunction: 'linear' }}
        >
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2">
            <div className="h-2.5 w-2.5 rounded-full bg-primary shadow-[0_0_8px_hsl(var(--primary)/0.4)]" />
            <div className="absolute inset-0 animate-ping rounded-full bg-primary opacity-50" />
          </div>
        </div>
      </div>
      {text ? (
        <p className="animate-pulse text-sm font-medium tracking-tight text-slate-500">{text}</p>
      ) : null}
    </div>
  );
}
